	<form [formGroup]="formGroup" (ngSubmit)="submit()" autocomplete="off" formName="PfmFundsDetailForm" >
    <div class="funds-cat-icon-wrapper">
      <div class="funds-cat-icon">
        {{commonService.getNameInitial(pfmFundsDetailFormHelper.pfmMainService.selectedPfmFundData?.frequencyDesc)}}
      </div>
  </div>
    <div class="entry-form">
      <div class="funds-category-details">
        <span class="funds-category-title">{{pfmFundsDetailFormHelper.pfmMainService.selectedPfmFundData.frequencyDesc}} Cashflow
          <span class="funds-category-month"> ({{state.currentPfmFundsDate}})</span>
        </span>
        <span class="funds-amount">
          <span class="funds-tranTotal">{{commonService.formatAmount(pfmFundsDetailFormHelper.pfmMainService.selectedPfmFundData.tranTotal)}}</span>
          <span class="funds-currency">{{commonService.baseCurrency}} </span>
          </span>
      </div>
      <div class="main-grid-container">
        <app-pfm-funds-history-display-grid
        [refreshCriteria$]="state.refreshCriteria$"></app-pfm-funds-history-display-grid>

        <!-- <div class="not-found" [ngStyle]="{'display': (state.isCategoryHistoryEmpty) ? 'block' : 'none' }">
          <div class="not-found-image-notif">
            <img class="noti-img" src="./assets/images/empty-transactions.svg" id="leftImg" alt="image1" />
          </div>
          <div class="no-notifi-text-empty">No data available</div>

        </div> -->
      </div>
      <!-- <div class="tab-container">
          <div class="mat-content" (touchstart)="pfmFundsDetailFormHelper.swipe($event, 'start')"
          (touchend)="pfmFundsDetailFormHelper.swipe($event, 'end')">
        <mat-tab-group  [(selectedIndex)]="state.selectedTab" (selectedTabChange)="pfmFundsDetailFormHelper.tabChanged($event)">
          <mat-tab label="{{pfmFundsDetailFormHelper.pfmMainService.selectedPfmFundData.frequencyDesc}} Cashflow">
            
          </mat-tab>
          <mat-tab label="Insights">
            <div class="grid-container">

            </div>
          </mat-tab>
        </mat-tab-group>
        </div>
      </div> -->
     </div>
	</form>

